import BaseService from '../base.service'
import { getClientId } from 'src/_helpers'
const endpoint = 'api/chat/public'
export class DirectMessagingFEService extends BaseService {
  constructor(parameters = {}) {
    super(endpoint, parameters)
  }
  history (site) {
    return this.submit('get', `${endpoint}/history/${site}/${getClientId()}`)
  }
  join (site, room, data) {
    return this.submit('post', `${endpoint}/join/${site}/${room}/${getClientId()}`, data)
  }
  send (site, data) {
    return this.submit('post', `${endpoint}/history/${site}/${getClientId()}`, data)
  }
}